import { render, staticRenderFns } from "./GoodsBackEdit.vue?vue&type=template&id=9a254d6c"
import script from "./GoodsBackEdit.vue?vue&type=script&lang=js"
export * from "./GoodsBackEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports